if ( module.hot ) {
  module.hot.accept();
}

// handles online booking
var OnlineBooking = {

    /**
     * Enabled booking vendor || false
     * @type string
     */
    vendor: $('body').data('booking-vendor'),
    
    init:function(){
        this.bindEvents();
    },

    /**
     * Add event listeners
     * @return {void}
     */
    bindEvents:function(){
        $('.gpw-booking').on('click', OnlineBooking.handleBookingClick);
    },

    /**
     * Callback - Fires booking vendor modal or does nothing if booking vendor doesn't have a booking modal
     * @param  {object} e  event object
     * @return {void}
     */
    handleBookingClick:function(e){
        // If not a modal link - return
        if (this.getAttribute("href") != "#") return;

        e.preventDefault();
        // Trigger click on 3rd part booking btn
        if(OnlineBooking.vendor == 'localMed') {
            $('.localmed-tab')[0].click(); // localMed modal - btn fixed to side of browser chrome.
        } else if (OnlineBooking.vendor == 'healthEngine') {
            $('#health-engine-book img').trigger('click'); // healthEngine modal - The btn in hidden in the footer.
        } else if (OnlineBooking.vendor == 'myHealth1st') {
            $('.1stAvailableWidget').trigger('click'); // myHealth1st (1stAvlailable) modal - The btn in hidden in the footer.
        }
    }
}

OnlineBooking.init();



// WEBPACK FOOTER //
// ./gpw-online-booking.js